// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.2 3.4H10.8C11.38 3.4 11.93 3.65 12.31 4.09L14.02 6.08C14.49 6.62 14.46 7.44 13.97 7.95L9.09 12.89C8.49 13.5 7.51 13.5 6.91 12.89L2.03 7.95C1.54 7.44 1.51 6.62 1.98 6.08L3.69 4.09C4.07 3.65 4.62 3.4 5.2 3.4Z',
  'M2.03 6.95H13.97',
  'M5.25 6.95L8 13.05L10.75 6.95',
];
